/**
 * LoginScreen React component
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import LockIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import logo from "../../musos_logo.png";
import logoPulsar from "../../pulsar-light-transparent.png";
import {login} from "../../operations/login";
import {DEMO_MODE} from "../../config";

/**
 * LoginScreen is a pretty decent, simple, but not too ordinary login screen
 *
 * @author Jens Gruschel
 */
export class LoginScreen extends React.Component {

    state = {
        email: DEMO_MODE ? "demo@contexagon.com" : "",
        password: DEMO_MODE ? "musos" : "",
        showPassword: false,
    };

    setEmail = event => {
        const email = event.target.value;
        this.setState(state => ({email: email}));
    }

    setPassword = event => {
        const password = event.target.value;
        this.setState(state => ({password: password}));
    }

    handleLogin = event => {
        event.preventDefault();
        this.props.login(this.state.email, this.state.password);
        return false;
    };

    render() {
        switch(this.props.theme) {
            case "pulsar":
                return this.renderPulsarLogin();
            default:
                return this.renderMusosLogin();
        }
    }

    /** render header, side bar and current page */
    renderMusosLogin() {
        const {classes} = this.props;

        return (
            <div className={classes.screen}>
                <div className={classes.main}>
                    <CssBaseline/>
                    <Paper className={classes.paper}>
                        <div className={classes.logoBox}>
                            <img src={logo} className={classes.logo} alt="logo"/>
                        </div>
                        <div className={classes.content}>
                            <Avatar className={classes.avatar}>
                                <LockIcon/>
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Anmelden
                            </Typography>
                            <form className={classes.form} onSubmit={this.handleLogin}>
                                <FormControl margin="normal" required fullWidth>
                                    <InputLabel htmlFor="email">E-Mail-Adresse</InputLabel>
                                    <Input id="email" name="email" defaultValue={this.state.email} autoComplete="email" autoFocus onChange={this.setEmail} />
                                </FormControl>
                                <FormControl margin="normal" required fullWidth>
                                    <InputLabel htmlFor="password">Passwort</InputLabel>
                                    <Input id="password" name="password" type="password" defaultValue={this.state.password} autoComplete="current-password" onChange={this.setPassword} />
                                </FormControl>
                                {/*<FormControlLabel
                                    control={<Checkbox value="remember" color="primary"/>}
                                    label="Remember me"
                                />*/}
                                {
                                    DEMO_MODE && <Typography component="p" className={classes.note}>zum Ausprobieren mit E-Mail-Adresse <span className={classes.example}>demo@contexagon.com</span> und Passwort <span className={classes.example}>musos</span> anmelden</Typography>
                                }
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                >
                                    Anmelden
                                </Button>
                            </form>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }

    renderPulsarLogin() {
        const {classes} = this.props;

        return (
            <div className={classes.screenPulsar}>
                <div className={classes.main}>
                    <CssBaseline/>
                    <img src={logoPulsar} className={classes.logoPulsar} alt="logo"/>
                    <Paper className={classes.paperPulsar}>
                        <div className={classes.content}>
                            <Avatar className={classes.avatar}>
                                <LockIcon/>
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Anmelden
                            </Typography>
                            <form className={classes.form} onSubmit={this.handleLogin}>
                                <FormControl margin="normal" required fullWidth>
                                    <InputLabel htmlFor="email">E-Mail-Adresse</InputLabel>
                                    <Input id="email" name="email" defaultValue={this.state.email} autoComplete="email" autoFocus onChange={this.setEmail} />
                                </FormControl>
                                <FormControl margin="normal" required fullWidth>
                                    <InputLabel htmlFor="password">Passwort</InputLabel>
                                    <Input id="password" name="password" type="password" defaultValue={this.state.password} autoComplete="current-password" onChange={this.setPassword} />
                                </FormControl>
                                {/*<FormControlLabel
                                    control={<Checkbox value="remember" color="primary"/>}
                                    label="Remember me"
                                />*/}
                                {
                                    DEMO_MODE && <Typography component="p" className={classes.note}>zum Ausprobieren mit E-Mail-Adresse <span className={classes.example}>demo@contexagon.com</span> und Passwort <span className={classes.example}>musos</span> anmelden</Typography>
                                }
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                >
                                    Anmelden
                                </Button>
                            </form>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    screen: {
        backgroundImage: 'url("images/background.svg")',
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    screenPulsar: {
        //backgroundImage: 'url("images/backgroundPulsar.svg")',
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundColor: "#083745"
    },
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        overflow: "hidden"
    },
    paperPulsar: {
        overflow: "hidden"
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
        width: 'auto'
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    logoBox: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        padding: 20
    },
    logo: {
        height: "40px",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto"
    },
    logoPulsar: {
        height: "400px",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto"
    },
    note: {
        marginTop: 10,
        padding: 10,
        backgroundColor: "#147c9155",
        color: "#ffffff"
    },
    example: {
        color: "#555555",
        backgroundColor: "#ffffff99",
        borderRadius: 3,
        padding: 3
    }
});

export default connect(undefined, {login})(withStyles(styles)(LoginScreen));